import EventBus from '../../../shared/js/wirebox/event-bus'
import jQuery from 'jquery'
import '../../../shared/js/utilities/xhr-error-message'

class HelpForm {
    
    /**
     * Construct component
     * @param form
    */
    constructor(form) {
        
        /**
         * Form jQuery object
         * @type {object}
        */
        this.form = form
        
        /**
         * Form tab jQuery object
         * @type {object}
        */
        this.formTab = jQuery('#help-form-tab')
        
        /**
         * Rep tab jQuery object
         * @type {object}
        */
        this.repTab = jQuery('#help-rep-tab')
        
        /**
         * Rep content jQuery object
         * @type {object}
        */
        this.repContent = jQuery('#help-rep-content')
        
        /**
         * Rep label jQuery object
         * @type {object}
        */
        this.repLabel = jQuery('#help-rep-label')
        
        /**
         * Back button jQuery object
         * @type {object}
        */
        this.backBtn = jQuery('#help-back-btn')
        
        this.bindEvents()
        
    }
    
    /**
     * Handle successful form submit
     * @param event
     * @param params
    */
    formSuccess(event, params) {
        
        //Get rep
        const rep = params.response.rep
        
        //Render HTML
        this.repContent.html(`
            <ul class="list-unstyled">
                ${rep.name ? ('<li>' + rep.name + '</li>') : ''}
                <li>
                    <a href="mailto:${rep.email}">
                        <i aria-hidden="true" class="icon-mail"></i>
                        ${rep.email}
                    </a>
                </li>
                <li>
                    <a href="tel:${rep.telephoneIntl}">
                        <i aria-hidden="true" class="icon-phone"></i>
                        ${rep.telephone}
                    </a>
                </li>
            </ul>
        `)
        
        //Show rep label
        this.repLabel.show()
        
        //Hide form tab
        this.formTab.hide()
        
        //Show rep tab
        this.repTab.fadeIn()
        
    }
    
    /**
     * Form error
     * @param event
     * @param xhr
    */
    formError(event, xhr) {
        
        var
            errors,
            html = '<ul class="list-unstyled text-danger">'
        
        //Load error messages from XHR response
        EventBus.publish('xhr-error-message', {
            xhr: xhr,
            callback: (messages) => {
                errors = messages
            }
        })
        
        //Construct HTML
        
        jQuery.each(errors, (i, error) => {
            html += '<li>' + error + '</li>'
        })
        
        html += '</ul>'
        
        //Update rep HTML
        this.repContent.html(html)
        
        //Hide rep label
        this.repLabel.hide()
        
        //Hide form tab
        this.formTab.hide()
        
        //Show rep tab
        this.repTab.fadeIn()
        
        
    }
    
    /**
     * Back button click
    */
    backBtnClick() {
        
        //Hide rep tab
        this.repTab.hide()
        
        //Show form tab
        this.formTab.fadeIn()
        
    }
    
    /**
     * Bind events
    */
    bindEvents() {
        
        //Form success
        this.form.on('form-ajax-success', this.formSuccess.bind(this))
        
        //Form error
        this.form.on('form-ajax-error', this.formError.bind(this))
        
        //Back button click
        this.backBtn.click(this.backBtnClick.bind(this))
        
    }
    
}

EventBus.subscribe('init-modules',  () => {
    
    let form = jQuery('#help-form')
    
    if (form.length > 0) {
        new HelpForm(form)
    }
    
})

export default HelpForm